var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","color":_vm.color},on:{"click":function($event){return _vm.doHandlerClick()}}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.iconCls))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }